module.exports = __webpack_public_path__ + "img/b7e09e5.png";